import React from "react";
import styled from "styled-components";
import { useApp } from "../../contexts";

const Wraper = styled.div`
  width: 542px;
  background: #fff;
  border-radius: 10px;

  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    width: 457px;
    height: 135px;
  } 
  @media screen and (max-width: 1024px) {
    width: 320px;
  }
  @media screen and (max-width: 370px) {
    width: 300px;
  }
`;

export const CardEventYoutube = () => {
  const { isMobile } = useApp();
  const handleClick = () => {
    window.open(process.env.REACT_APP_LINK_SUZU_YOUTUBE, "_blank");
  };
  return (
    <Wraper className="cursor-pointer" onClick={handleClick}>
      <img
        style={{ width: "100%", height: "100%" }}
        src={
          isMobile
            ? "/assets/images/event_affiliate_ytb_mb.png"
            : "/assets/images/event_affiliate_ytb.png"
        }
        alt=""
      />
    </Wraper>
  );
};
